export var IdCoopMemberActivityClassName;
(function (IdCoopMemberActivityClassName) {
    IdCoopMemberActivityClassName["last20min"] = "last20min";
    IdCoopMemberActivityClassName["last24hours"] = "last24hours";
    IdCoopMemberActivityClassName["last48hours"] = "last48hours";
    IdCoopMemberActivityClassName["last7days"] = "last7days";
    IdCoopMemberActivityClassName["other"] = "other";
    IdCoopMemberActivityClassName["prefix"] = "member-activity-background-";
})(IdCoopMemberActivityClassName || (IdCoopMemberActivityClassName = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/IdCoopMemberActivityClassName.ts
// module id = 1364
// module chunks = 3